import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Email|Properties|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogsEmailsProperties';
export type SPCatalogsEmailsPropertiesLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}ButtonEdit`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonSave`
	| `${LocNameStart}LabelFromName`
	| `${LocNameStart}LabelFromEmail`
	| `${LocNameStart}LabelDisabled`
	| `${LocNameStart}LabelBcc`;

export const spCatalogsEmailsPropertiesLocs: LocDefs<SPCatalogsEmailsPropertiesLocNames> = {
	SPCatalogsEmailsPropertiesTitleSection: {
		defaultValue: 'Properties',
		description: 'Section title',
		displayPath: `${pathStart}Section title`,
		displayType: 'Title',
		legacyName: 'Core/Catalogs.Emails.Details.Title.Properties',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesButtonEdit: {
		defaultValue: 'Edit',
		description: 'Edit button',
		displayPath: `${pathStart}Edit`,
		displayType: 'Button',
		legacyName: 'Core/Catalogs.Emails.Details.Button.PropertiesEdit',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		legacyName: 'Core/Catalogs.Emails.Details.Button.PropertiesCancel',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesButtonSave: {
		defaultValue: 'Save',
		description: 'Save button',
		displayPath: `${pathStart}Save`,
		displayType: 'Button',
		legacyName: 'Core/Catalogs.Emails.Details.Button.PropertiesSave',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesLabelFromName: {
		defaultValue: 'From Name',
		description: 'Label for: From Name.',
		displayPath: `${pathStart}From Name`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.FromName',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesLabelFromEmail: {
		defaultValue: 'From Email',
		description: 'Label for: From Email.',
		displayPath: `${pathStart}From Email`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.FromEmail',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesLabelDisabled: {
		defaultValue: 'Disabled',
		description: 'Label for: Disabled.',
		displayPath: `${pathStart}Disabled`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.Disabled',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesLabelBcc: {
		defaultValue: 'BCC',
		description: 'Label for: BCC.',
		displayPath: `${pathStart}BCC`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.BCC',
		...sharedProperties,
	},
};

export type SPCatalogsEmailsPropertiesLocType = LocMap<SPCatalogsEmailsPropertiesLocNames>;
